package org.example.zone360.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class DashboardChatState {

    val messages = mutableStateListOf<ChatBotMessage>()

    var isButtonLoading by mutableStateOf(false)

    var isQuickActionLoading by mutableStateOf(false)
}